import { render } from "./card_dashboard.vue?vue&type=template&id=1fdf3af3"
import script from "./card_dashboard.vue?vue&type=script&lang=js"
export * from "./card_dashboard.vue?vue&type=script&lang=js"

import exportComponent from "/media/ctis/developer/WorkSpaceFront/cdas-intranet-ui/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__